import React from 'react'
import { useStateValue } from '@State'

export const CanvasAuthorize = () => {
  const [state] = useStateValue()
  let authLink = `/links/client_canvas.authorize_v2/${state.coursenum}/`

  return (
    <div className="card-myed">
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h3>2. Authorize</h3>
          <div className="description">
            <ol>
              <li>
                Click the &quot;Authorize&quot; button below to go to your
                Canvas login screen.
              </li>
              <li>
                Log in to Canvas to authorize the connection from MyEducator
                to Canvas.
              </li>
              <li>
                After you log in, you will be redirected to the next step in
                MyEducator.
              </li>
            </ol>
          </div>
          <div className="form-control-wrapper">
            <a
              className="btn btn-myed btn-primary btn-primary-myed"
              href={authLink}
            >
              Authorize <div className="fa-solid fa-chevron-right ml-2" />
            </a>
          </div>
        </div>
        <div className="canvas-statusmarker-container">
          <img src="/static/instructor/media/canvas-logo-lms.png" />
        </div>
      </div>
    </div>
  )
}

